import MenuIcon from "@mui/icons-material/Menu";
import { Box, IconButton, styled } from "@mui/material";
import LanguageSelector from "components/views/language-selector/LanguageSelector";

const MobileStyledLogo = styled("img")(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(3),
  left: theme.spacing(4),
  height: "27px",
  width: "auto",
}));

type MobileMenuButtonProps = {
  onClick: () => void;
  logoOnly?: boolean;
  showLanguageSelector?: boolean;
};

const HeaderActionsPositioner = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(3),
  right: theme.spacing(5),
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

const CircularMenuButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export const MobileMenuButton = ({ onClick, logoOnly = true, showLanguageSelector = false }: MobileMenuButtonProps) => (
  <>
    <MobileStyledLogo src={"ISSVR_Logo.png"} alt="logo" />
    {(logoOnly || showLanguageSelector) && (
      <HeaderActionsPositioner>
        {showLanguageSelector && <LanguageSelector verticalOffset="0px" />}
        {logoOnly && (
        <CircularMenuButton onClick={onClick}>
          <MenuIcon />
        </CircularMenuButton>
        )}
      </HeaderActionsPositioner>
    )}
  </>
);
